import React, {Fragment} from "react";
import {Grid} from "@mui/material";
import SectionHeading from "../SectionHeading";
import RelevantLinkBlock from "../fragments/RelevantLinkBlock";
import {Link} from "react-router-dom";

export default function TireStorage() {

    let relevantUrls = ["/service", "/service/tireServicePrice"];

    let itemData = [
        {
            img: '/images/tire-storing.jpg',
            title: 'Шиномонтаж',
            rows: 2,
            cols: 2,
        },
        {
            img: '/pictures/autoservice/tire/IMG_6025.JPG',
            title: 'Шиномонтаж',
        },
        {
            img: '/pictures/IMG_5668.JPG',
            title: 'Офис белавтоэксперт',
        },
        {
            img: '/images/tire-repair.jpeg',
            title: 'Хранение шин',
            cols: 2,
        },

    ];

    return (
        <div className="site-section">
            <div className="container">

                <Grid container spacing={0}>
                    <Grid xs={12} md={8} lg={9}>
                        <SectionHeading sectionHeadingTitle={"Сервисное хранение шин"}
                                        sectionHeadingMessage={<>
                                            Наша компания предлагает услугу специализированного хранения шин.<br/>
                                            Хранить шины в БелАвтоЭксперт — это наилучший выбор.<br/>
                                            Наши специалисты гарантируют правильное обращение с Вашей резиной. Перед
                                            хранением шины проходят мойку и очистку протектора. <br/>
                                            Мы строго соблюдаем стандарты хранения: шины находятся в специально
                                            оборудованных складах с
                                            оптимальными температурой и влажностью, вдали от солнечного света.<br/>
                                            Регулярно осуществляем проверку их состояния и при необходимости
                                            выполняем рекомендации по уходу.<br/>
                                            У нас гибкие условия хранения, доступные <Link
                                            to="/service/tireServicePrice">цены</Link> и высокий уровень сервиса.
                                        </>}
                                        images={itemData}/>
                        <p>Если Вы всё же решили хранить шины самостоятельно, предлагаем ознакомиться с некоторыми
                            правилами, следуя которым Вы сможете избежать риска деформаций, трещин и сохранить
                            автомобильные шины в отличном состоянии.
                        </p>
                        <div className="ratio ratio-16x9 my-3">
                            <iframe width="560" height="315"
                                    src="https://www.youtube.com/embed/giawuVhSnzI?si=GIZdblkSljslutYe"
                                    title="Видео - Как правильно хранить шины"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowFullScreen></iframe>
                        </div>
                        <ol>
                            <li>Найдите подходящее место
                                <p>Шины должны храниться в сухом, чистом и хорошо вентилируемом помещении при t от +10°С
                                    до +25°С.
                                    Убедитесь, что на шины не попадает солнечный свет: ультрафиолет разрушает резину.
                                </p>
                            </li>
                            <li>Подпишите шины, чтобы различать их при следующей установке
                                <p>После снятия шин подпишите правые и левые, передние и задние шины. В дальнейшем это
                                    может упростить их процесс монтажа.
                                </p>
                            </li>
                            <li>Почистите шины перед хранением
                                <p>Удалите камни, очистите от пыли и грязи и просушите шины. Обработайте специальным
                                    средством, которое предотвратит пересыхание резины. Следуйте инструкции по
                                    применению специальных средств по уходу за шинами.
                                </p>
                            </li>
                            <li>Разместите шины правильно
                                <p>Если Вы собираетесь хранить шины не снимая их с дисков, тогда храните горизонтально.
                                    Их можно положить друг на друга. Если Вы хотите сэкономить пространство, то можете
                                    подвесить каждую шину отдельно.
                                    Если Вы храните шины без дисков, то не храните их горизонтально и не подвешивайте
                                    их, т.к. это может привести к деформации шины и ускорить износ протектора. Храните
                                    шины вертикально. Лучше использовать вогнутую поверхность, как поддержку, чтобы
                                    предотвратить деформирование. Периодически, раз в 1-2 месяца поворачивайте шины,
                                    меняя точку опоры.
                                </p>
                            </li>
                            <li>Используйте специальные пакеты для хранения
                                <p>Используйте специальные пакеты, т.к. в обычных полиэтиленовых внутри может собираться
                                    конденсат. Пакеты помогут защитить шины от пыли и влаги.
                                </p>
                            </li>
                            <li>Защитите шины от мороза
                                <p>Если нет возможности хранить шины в тёплом помещении, обработайте их специальным
                                    защитным средством. Это убережёт их от растрескивания при низких температурах.
                                </p>
                            </li>
                            <li>Используйте сервисы для хранения шин
                                <p>Если у Вас нет подходящего места для хранения шин, Вы можете воспользоваться сервисом, предоставляющим данные услуги. Читайте договор внимательно, он должен отражать условия хранения шин.
                                </p>
                            </li>
                        </ol>
                    </Grid>
                    <Grid xs={12} md={4} lg={3}>
                        <RelevantLinkBlock relevantUrls={relevantUrls}/>
                    </Grid>
                </Grid>

            </div>
        </div>

    );

}